import React, { useState, useContext } from 'react';
import { Segment, Form, Button, Label } from 'semantic-ui-react';

import { observer } from 'mobx-react-lite';
import { Form as FinalForm, Field } from 'react-final-form';

import {
  combineValidators,
  isRequired,
} from 'revalidate';

import { RootStoreContext } from '../../../../App/stores/RootStore'
import TextInput from '../../../../App/common/form/TextInput';
import { AdminSettingFormValues } from '../../../../App/models/AdminSetting';

const validate = combineValidators({
  id: isRequired('id'),
  key: isRequired('key'),
  value: isRequired('value'),
});

interface AdminSettingParams {
  id: string;
  Adminkey: string;
  value: string;

}

const AdminSettingForm: React.FC<AdminSettingParams> = (match) => {
  const rootStore = useContext(RootStoreContext);

  const { createAdminSetting, editAdminSetting, submitting } = rootStore.adminSettingStore;
  const { closeModal } = rootStore.modalStore;

  const [adminSetting] = useState(new AdminSettingFormValues(match.id, match.Adminkey, match.value));
  const [loading] = useState(false);

  const handleFinalFormSubmit = (values: any) => {
    const { ...adminSetting } = values;

    if (!adminSetting.id) {
      let newAdminSetting = {
        ...adminSetting
      };
      createAdminSetting(newAdminSetting);
    }
    else {
      editAdminSetting(adminSetting);
    }
  };

  return (
    <Segment clearing>
      <FinalForm
        validate={validate}
        initialValues={adminSetting}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit, invalid, pristine }) => (
          <Form onSubmit={handleSubmit} loading={loading}>
            <Label>
              {adminSetting.key}
            </Label>

            <Field
              rows={4}
              name='value'
              placeholder='value'
              value={adminSetting.value}
              component={TextInput}
            />

            <Button
              loading={submitting}
              disabled={loading || invalid || pristine}
              floated='right'
              positive
              type='submit'
              content='Update'
            />

            <Button
              onClick={() => closeModal()}
              disabled={loading}
              floated='left'
              type='button'
              content='Cancel'
            />
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(AdminSettingForm);
